import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
import NavbarItem from './NavbarItem';
import logo from '../assets/images/sunshinelogo2.png';
import "../styles/Navbar.css";

const Navbar = ({ items = [] }) => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const [activeId, setActiveId] = useState(null);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 10);

    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Scroll-spy: marca en el nav la sección que se está mirando
  useEffect(() => {
    const sections = items
      .map(({ link }) => document.querySelector(link))
      .filter(Boolean);

    if (!sections.length) return;

    const observer = new IntersectionObserver(
      (entries) => {
        const visible = entries
          .filter((entry) => entry.isIntersecting)
          .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];

        if (visible) setActiveId(`#${visible.target.id}`);
      },
      { rootMargin: '-45% 0px -45% 0px', threshold: [0, 0.25, 0.5, 1] }
    );

    sections.forEach((section) => observer.observe(section));
    return () => observer.disconnect();
  }, [items]);

  return (
    <nav
      className={`nav-brandbar navbar navbar-expand-lg fixed-top ${
        scrolled || open ? 'solid' : 'transparent'
      }`}
    >
      <div className="container">
        <a className="navbar-brand" href="/">
          <img
            className="nav-brandbar__mark"
            src={logo}
            alt=""
          />
          <span className="nav-brandbar__word">
            <b>Sunshine Cleaning All</b>
            <span>Los Angeles, CA</span>
          </span>
        </a>

        <button
          className="navbar-toggler"
          type="button"
          onClick={() => setOpen((value) => !value)}
          aria-controls="navbarNav"
          aria-expanded={open}
          aria-label={open ? 'Close menu' : 'Open menu'}
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>

        <div
          className={`collapse navbar-collapse${open ? ' show' : ''}`}
          id="navbarNav"
        >
          <ul className="navbar-nav ms-auto" onClick={() => setOpen(false)}>
            {items.map(({ link, item }) => (
              <NavbarItem
                key={link}
                link={link}
                item={item}
                active={activeId === link}
              />
            ))}
          </ul>

          <button
            type="button"
            className="btn-sun nav-brandbar__cta"
            data-bs-toggle="modal"
            data-bs-target="#contactModal"
            onClick={() => setOpen(false)}
          >
            Get a quote
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
